module.exports = __webpack_public_path__ + "img/sv.730d149c.svg";